/* eslint-disable react-hooks/exhaustive-deps */
import { Alert } from "..";
import { useEffect, useState } from "react";
import { FxTranslate } from "../../core/translate";
import { PersonaEditIn } from "../../model/seguridad";
import { Button, ButtonProps } from "primereact/button";
import API from "../../services/api";
import { Dialog, Sidebar } from "../prime";
import CnetPersonaForm from "./CnetPersonaForm";

export interface CnetPersonaButtonProps extends ButtonProps {
  t: FxTranslate;

  /** Id de persona a editar */
  idPersona: number | undefined;

  /** DEFAULT modal. Forma de mostrar el modal con el formulario */
  formMode?: 'sidebar-left' | 'sidebar-right' | 'modal';

  /** DEFAULT: TRUE. Indica si el botón grabar invoca al API para que guarde los cambios o solo devuelve el objeto modificado */
  saveToAPI?: boolean;
  /** Ocurre cuando se guardan los cambios */
  onSave: (entity: PersonaEditIn) => void;
}
function CnetPersonaButton({ t, idPersona, formMode, saveToAPI, onSave,  ...props } : CnetPersonaButtonProps) {
  const [ loading, setLoading ] = useState<'none' | 'cargar' | 'cargando'>('none');
  const [ entity, setEntity ] = useState<PersonaEditIn|undefined>(undefined);
  const [ showForm, setShowForm ] = useState<'none' | 'sidebar-left' | 'sidebar-right' | 'modal'>('none');
  
  //useEffect(() => setLoading('cargar'), [idPersona]);

  const openModal = () => {
    setLoading('cargar');
  }

  useEffect(() => {
    if (loading !== 'cargar') return;
    setLoading('cargando');
    API.SeguridadController().Persona().getEdit({ id: idPersona }).then(res => {
      if (!res.success) return Alert.reponse(res);
      setEntity(res.data ?? { });
      setShowForm(formMode ?? 'modal');
      setLoading('none');
    }).catch(ex => Alert.exception(t, ex));
  }, [loading]);

  return <>
    <Button 
      loading={loading === 'cargando'}
      disabled={props.disabled}
      icon={!!entity?.id ? "pi pi-user-edit" : "pi pi-user-plus"}
      onClick={openModal}
      {...props as any}
    />

    <Sidebar
      visible={showForm === 'sidebar-left' || showForm === 'sidebar-right'}
      position={formMode === 'sidebar-left' ? 'left' : 'right'}
      style={{ width: '50%' }}
      onHide={() => setShowForm('none')}
    >
      <CnetPersonaForm 
        t={t} entity={entity} saveToAPI={!(saveToAPI === false)}
        onHide={() => setShowForm('none')}
        onSave={e => {
          setShowForm('none');
          onSave(e);
        }}
      />
    </Sidebar>
    
    <Dialog
      visible={showForm === 'modal'}
      //position={formMode === 'sidebar-left' ? 'left' : 'right'}
      onHide={() => setShowForm('none')}
    >
      <CnetPersonaForm 
        t={t} entity={entity} saveToAPI={!(saveToAPI === false)}
        onHide={() => setShowForm('none')}
        onSave={e => {
          setShowForm('none');
          onSave(e);
        }}
      />
    </Dialog>
  </>
}


export default CnetPersonaButton;